<script setup lang="ts">
interface Props {
  count?: number
  currentIndex: number
  showDisclaimer?: boolean
}

defineProps<Props>()

const emits = defineEmits(['next', 'previous', 'toggle-fullscreen'])
</script>

<template>
  <div
    class="fixed top-0 left-0 bg-black bg-opacity-70 z-30 w-full h-full flex flex-col gap-y-2 justify-center items-center sm:px-20"
    @click="emits('toggle-fullscreen')"
  >
    <div
      class="flex flex-row items-center justify-between p-5 absolute top-0 left-0 w-full"
    >
      <ImageCarouselFullscreenCount
        v-if="count"
        :count="count"
        :current-index="currentIndex"
      />
      <button
        class="text-brand-white w-10 h-10 flex items-center justify-center"
        @click="emits('toggle-fullscreen')"
      >
        <Icon name="material-symbols:close-rounded" size="50" />
      </button>
    </div>

    <div
      class="flex justify-center items-center max-w-screen-lg w-full relative max-h-[80%]"
    >
      <ImageCarouselFullscreenPrevious
        class="absolute left-0 sm:-left-[50px]"
        @previous="emits('previous')"
      />

      <slot />

      <ImageCarouselFullscreenNext
        class="absolute right-0 sm:-right-[50px]"
        @next="emits('next')"
      />
    </div>
    <p
      v-if="showDisclaimer"
      class="text-center text-brand-white absolute bottom-0 mb-10"
    >
      {{ $t('accommodation.disclaimer') }}
    </p>
  </div>
</template>
